import React, { useEffect, useState, useMemo, useRef } from "react";

import { CustomSpin as Spin } from "_components";
import { isNonEmptyArray, isNonEmptyObject, isEmpty } from "_helpers";
import { useDashboard } from "_hooks";
import { BasesStatus, LicensesListing } from "Pages";

import { Col, Empty, Menu, Row, Select } from "antd";
import { useNavigate } from "react-router-dom";

import { ReactComponent as DbStatus } from "_assets/dashboard/database-check.svg";
import { ReactComponent as Listing } from "_assets/dashboard/listing.svg";
import { ReactComponent as DropdownArrow } from "_assets/dropdown-arrow.svg";

const IsEmpty = ( ) => <div className="h-100 d-flex justify-content-center align-items-center">Rien à afficher</div> ;

export function Dashboard(){
    const defaultSelectedMenu = useRef("bases_status").current;

    const [ currentSelectedMenu, setCurrentSelectedMenu ] = useState(defaultSelectedMenu);
    const [ openKeys, setOpenKeys ] = useState([]);
    const [ selectedBase, setSelectedBase ] = useState();

    const { fetchBasesStatus, fetchLicensesList, fetchIsDone, dashboardDoRedirect } = useDashboard();

    const navigate = useNavigate();

    const bases = useMemo(() => {
        if( isEmpty(fetchLicensesList) ) return [];
        return Object.keys(fetchLicensesList).map(key => ({ value: key, label: key.split("@")[0] }));
    }, [fetchLicensesList]);
    const defaultSelectBasesValue = useMemo(() => bases?.[0]?.value ?? null, [bases]);

    const leftMenuItems = useMemo(() => ([
        {
            key: 'bases_status',
            label: 'Etat bases',
            icon: <DbStatus width={36} height={36} />
        },{
            key: 'licenses_listing',
            label: 'Liste des licences',
            icon: <Listing width={36} height={36} />,
            children: [
                {
                    key: 'licenses_listing_select',
                    label: (
                        <Select 
                            options={bases}
                            value={selectedBase}
                            className="w-100"
                            placeholder="Sélection"
                            showSearch
                            popupRender={(menu) => (
                                <>
                                    {
                                        isNonEmptyArray(bases) 
                                        ?
                                            menu
                                        :
                                        fetchIsDone
                                        ?
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        :
                                            <Spin />
                                    }
                                </>
                            )}
                            onChange={(val) => setSelectedBase(val)}
                        />
                    )
                }
            ]
        }
    ]),[bases, defaultSelectBasesValue, selectedBase, fetchIsDone]);

    useEffect(() => {
        document.title = 'Dashboard';
    }, []);

    useEffect(() => {
        if( dashboardDoRedirect ){
            navigate('/');
        }
    }, [dashboardDoRedirect]);

    useEffect(() => {
        setSelectedBase(defaultSelectBasesValue);
    }, [defaultSelectBasesValue]);

    useEffect(() => {
        if( currentSelectedMenu === 'bases_status' ) setOpenKeys(prevValue => prevValue.filter(e => e!== 'licenses_listing'));
    }, [currentSelectedMenu]);

    const toggleRenderComponent = (  ) => {
        switch( currentSelectedMenu ){
            case 'bases_status' :
                return ( isNonEmptyObject(fetchBasesStatus) ) ? <BasesStatus fetchData={fetchBasesStatus} /> : fetchIsDone ? <IsEmpty /> : <Spin /> ;
            case 'licenses_listing_select' :
                return ( isNonEmptyObject(fetchLicensesList) && selectedBase) 
                ?  
                    <LicensesListing 
                        fetchData={fetchLicensesList} 
                        selectedBase={selectedBase} 
                    /> 
                : 
                fetchIsDone 
                ? 
                    <IsEmpty /> 
                : 
                    <Spin /> ;
            default :
                return ;
        }
    };

    const handleMenuSelectChange = ({ key }) => {
        setCurrentSelectedMenu(key)
    }
    const handleMenuOpenChange = ( keys ) => {
        setOpenKeys(keys);
    }

    return(
        <div className="h-100">
            <Row gutter={16} className="h-100">
                <Col xs={4}>
                    <Menu
                        items={leftMenuItems}
                        className="h-100"
                        mode="inline"
                        defaultSelectedKeys={[defaultSelectedMenu]}
                        openKeys={openKeys}
                        expandIcon={({ isOpen }) => <DropdownArrow transform={isOpen ? "rotate(180)" : undefined} className="expand-icon"/>}
                        onSelect={handleMenuSelectChange}
                        onOpenChange={handleMenuOpenChange}
                    />
                </Col>
                <Col xs={20}>
                    { toggleRenderComponent() }
                </Col>
            </Row>
        </div>
    );
}